export default __webpack_public_path__ + "img/029ef1eb91823806eddde810f39164b5.svg";